import React from "react";
import Button from "../../../../components/Button.jsx";
import overlayAnim from "../../../../css/components/overlaymodal-animations.module.css";
import styles from "../css/clinic-services.module.css";
import FormInput from "../../../../components/FormInput.jsx";

export default function AddEditServiceModal({ open, onClose, onSave, initialData, onError }) {
  const [form, setForm] = React.useState(() => ({
    servicecode: initialData?.servicecode || "",
    servicename: initialData?.servicename || "",
    price: initialData?.price || "",
    durationinmin: initialData?.durationinmin || "",
    description: initialData?.description || "",
  }));

  React.useEffect(() => {
    setForm({
      servicecode: initialData?.servicecode || "",
      servicename: initialData?.servicename || "",
      price: initialData?.price || "",
      durationinmin: initialData?.durationinmin || "",
      description: initialData?.description || "",
    });
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!form.servicename || !form.price || !form.durationinmin) {
      if (onError) {
        onError('Please fill in all required fields: Service Name, Price, and Duration');
      }
      return;
    }
    const priceValue = Number(form.price);
    const durationValue = Number(form.durationinmin);

    if (Number.isNaN(priceValue) || Number.isNaN(durationValue) || priceValue < 1 || durationValue < 1) {
      if (onError) {
        onError('Price and Duration must both be at least 1');
      }
      return;
    }
    const dataToSave = { ...form };
    if (initialData?.serviceid) {
      dataToSave.serviceid = initialData.serviceid;
    }
    onSave(dataToSave);
    // Don't close modal here - let parent component close it on successful save
  };

  if (!open) return null;

  return (
    <div
      className={`${overlayAnim.modalOverlay} ${open ? overlayAnim.show : overlayAnim.hide}`}
      onClick={onClose}
    >
      <div
        className={`${overlayAnim.modalContent} ${styles.modalCard}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={overlayAnim.closeButton} onClick={onClose}>
          ×
        </button>
        <div className={styles.modalHeader}>
          <h2>{initialData?.serviceid ? 'Edit Service' : 'Add New Service'}</h2>
          <p>{initialData?.serviceid ? 'Update the service details' : 'Create a new service offering for the clinic'}</p>
        </div>

        <div className={styles.formGrid}>
          <FormInput
            className={styles.formGroup}
            label="Service Code"
            name="servicecode"
            type="text"
            value={form.servicecode}
            onChange={handleChange}
          />
          <FormInput
            className={styles.formGroup}
            label="Service Name"
            name="servicename"
            type="text"
            value={form.servicename}
            onChange={handleChange}
          />
          <FormInput
            className={styles.formGroup}
            label="Price (R)"
            name="price"
            type="number"
            value={form.price}
            onChange={handleChange}
            min={1}
            onBlur={() => {}}
          />
          <FormInput
            className={styles.formGroup}
            label="Duration (minutes)"
            name="durationinmin"
            type="number"
            value={form.durationinmin}
            onChange={handleChange}
            min={1}
          />
          <div className={`${styles.formGroup} ${styles.fullWidth}`}>
            <label>Description</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              placeholder="Enter Service Description"
              rows={3}
            />
          </div>
        </div>

        <div className={styles.modalFooter}>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit}>Save</Button>
        </div>
      </div>
    </div>
  );
}
